import { Form } from "semantic-ui-react";
import { instanceAxios } from "../../../hooks/useApiDiretorio";
import { useEffect, useState } from "react";
import SelecionaZonalModal from "./SelecionaZonalModal";

function CidadeSelect({ estado, onChange, onBlur, error, value }) {
  const [data, setData] = useState([]);
  const [zonais, setZonais] = useState([]);
  const [escolheZonal, setEscolheZonal] = useState(false);
  const [carregandoCidade, setCarregandoCidade] = useState(false);

  useEffect(() => {
    if (! estado) return; 
    setCarregandoCidade(true);
    instanceAxios.get(`/municipio/${estado}`).then((response) => {
      setData(response.data);
      setCarregandoCidade(false);
    });
  }, [estado]);

  const getOptionsCidade = () => {
    let options = [];

    options = data.map((s) => ({
      key: s.codigoMunicipio,
      value: s.codigoMunicipio,
      text: s.nomeMunicipio,
    }));

    options.unshift({key: -1});

    return options;
  };

  const verificaZonal = (e, dataCidade) => {
    onChange('municipioFiliacao', dataCidade.value);
    if (! dataCidade || dataCidade.length === 0 || ! estado || estado.length === 0) return; 
    instanceAxios.get(`/diretorio-zonal/${dataCidade.value}`).then((response) => {
      if (response.data.length > 0) {
        setZonais(response.data);
        setEscolheZonal(true);
      }
    });
  };

  return (
    <>
    <Form.Select
      fluid
      search
      loading={carregandoCidade}
      label="Cidade"
      name="municipioFiliacao"
      error={error}
      value={value}
      options={getOptionsCidade()}
      onChange={verificaZonal}
      onBlur={onBlur}
      required
      width={12}
    />
    <SelecionaZonalModal setIsOpen={setEscolheZonal} isOpen={escolheZonal} onChangeZonal={onChange} zonais={zonais}/>
    </>
  );
}

export default CidadeSelect;
